import MapPin, { MapIconType } from '../pin/MapPin';

function someIcon(iconType: MapIconType, displayNumber?: number) {
  return <MapPin iconType={iconType} {...(displayNumber !== undefined && { displayNumber })} />;
}

export default someIcon;
